// HowToImprove.tsx
import React from 'react';
import './HowToImprove.scss';
import { DetailDataItem } from '../../Analytics2/types/types';
import Iterations from './Iterations';
import { ITERATIONS } from '../../CreativeAnalytics/ReportCard/constants';
import { SuggestionsContainer } from './Suggestions/Container';

interface HowToImproveProps {
  visual: DetailDataItem;
  iterationsData?: any[];
}

const HowToImprove: React.FC<HowToImproveProps> = ({
  visual,
  iterationsData = [],
  start_date,
  end_date,
  activeTab,
}) => {
  return (
    <div className="how-to-improve">
      {/* <div className="card">
        <h3 className="subheader">Performance Insights</h3>
        <div className="insights-content">
          <p>Based on the performance data for this visual:</p>
          <ul>
            <li>Current CPA: {visual.total_cpa}</li>
            <li>Total Spend: ${visual.total_spend.toLocaleString()}</li>
            <li>Total Results: {visual.total_results.toLocaleString()}</li>
          </ul>
        </div> */}
      {/* </div> */}

      <SuggestionsContainer
        visual={visual}
        activePage={activeTab}
        {...{ start_date, end_date }}
      />
    </div>
  );
};

export default HowToImprove;
